module.exports = __webpack_public_path__ + "img/何首乌.f9cfa197.jpg";